import tokens from '@fcc/tokens/dist/tokens.json';
import styled from 'styled-components';

export const Overlapping = styled.div<{ color: string; count: number; isActive: boolean }>`
    display: inline-block;
    vertical-align: 2px;
    line-height: 0;

    &:not(:first-child) {
        margin-left: -12px;
    }

    & > svg:first-child {
        vertical-align: middle;
    }

    & > svg:not(:first-child) {
        margin-left: -20px;
        vertical-align: middle;
        fill: ${({ color, count, isActive }) => {
            const currentColor = isActive ? `#${color}` : tokens.color.primary.brand.primary;
            const opacity =
                {
                    1: '66', // 0.4,
                    2: '99', // 0.6,
                    3: 'CC', // 0.8,
                }[count] || 1;
            return `${currentColor}${opacity}`;
        }};
    }
`;
